import React from 'react';

function CheckmarkCircle() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M12,0 C5.37600001,0 0,5.37600001 0,12 C0,18.6240005 5.37600001,24 12,24 C18.6240005,24 24,18.6240005 24,12 C24,5.37599945 18.6240005,0 12,0 Z M9.6,18 L3.6,12 L5.29199981,10.3080001 L9.6,14.604 L18.7080001,5.4959999 L20.4,7.2 L9.6,18 Z"
        id="Fill-2"
      />
    </svg>
  );
  /* eslint-enable */
}

export default CheckmarkCircle;



// WEBPACK FOOTER //
// ./src/common/icons/CheckmarkCircle.js